//////////////////////////////////////////////////////////////////////
//
//  10/04/18
//  src/components/CompactRow.js
//
//  This file is a single row of compact data.
//

import React   from 'react';
import NameBlk from "./NameBlk";
import './CompactRow.css';

const CompactRow = ({ miles, name, row, music, food, happy, notes, mpop, fpop, hpop, addr }) => (
  <div className="CompactRow">

    <div className="CompactRowName">
      <NameBlk row={ row }     name={ name } miles={ miles } type={ "compact" }
               music={ music } food={ food } happy={ happy } notes={ notes }
               mpop ={ mpop  } fpop={ fpop } hpop ={ hpop  } addr ={ addr  } />
    </div>

  </div>
);

export default CompactRow;




// WEBPACK FOOTER //
// ./src/components/CompactRow.js